'use strict';

import {BaseElement} from "../../interfaces/BaseElement";

export class SearchResultsNotificator {
  static #element = null;
  static #informationElement = null;
  static #counter = 0;
  constructor() {
    if (SearchResultsNotificator.#element)
      return;

    SearchResultsNotificator.#element = new BaseElement()
      .addClass('search__results-notificator', 'hidden');
    SearchResultsNotificator.#informationElement = new BaseElement('span')
      .addClass('results-notificator__information')
      .appendTo(SearchResultsNotificator.#element.DOMElement);

    SearchResultsNotificator.update();
  }

  static update() {
    const countAmountElement = document.querySelector('.search__result-count--amount');
    if (!SearchResultsNotificator.#element || !countAmountElement)
      return;

    SearchResultsNotificator.#counter = parseInt(countAmountElement.innerHTML);
    SearchResultsNotificator.#counter > 0 ?
      SearchResultsNotificator.#element.removeClass('hidden'):
      SearchResultsNotificator.#element.addClass('hidden');
    SearchResultsNotificator.#informationElement.innerHtml(SearchResultsNotificator.#counter);
  }

  appendTo(parentElement) {
    if (parentElement && SearchResultsNotificator.#element)
      parentElement.appendChild(SearchResultsNotificator.#element.DOMElement);
  }
}